import { args, declareEvent, RxEvent } from "@cloudextend/common/events";

export const NAVIGATION_VERB = "common:routes:Navigation";

export interface NavigationEvent extends RxEvent {
    verb: "common:routes:Navigation";
    pathSegments: unknown[];
    params?: Record<string, unknown>;
}

export const navigate = declareEvent(
    NAVIGATION_VERB,
    args<{
        pathSegments: string[];
        params?: Record<string, unknown>;
        queryParams?: Record<string, unknown>;
    }>()
);
